/*=========================================================================================
  File Name: moduleTodoGetters.js
  Description: Todo List Module Getters
==========================================================================================*/
import _ from "lodash";

const formatProperties = properties => {
	const parsedProperties = properties ? JSON.parse(properties) : {};
	return {
		...parsedProperties,
		report: _.get(parsedProperties, "report") || null,
		is_done: _.get(parsedProperties, "is_done") || false,
		device_name: _.get(parsedProperties, "device_name") || "",
		priority: _.get(parsedProperties, "priority") || 0,
		start_date: _.get(parsedProperties, "start_date") || "",
		due_date: _.get(parsedProperties, "due_date") || 0
	};
};

const formatRelation = relation => {
	let devicesName = [];
	let deviceId = null;
	if (relation && relation.length > 0) {
		relation.map(rel => {
			devicesName.push(rel.display);
			deviceId = rel.id;
		});
	}
	return {
		device_name: devicesName,
		device_id: deviceId
	};
};

export default {
	getParsedMissionList: state =>
		state.missions.map(item => ({
			...item,
			readableProperties: formatProperties(item.properties || {}),
			relationDevices: formatRelation(item.relations || {})
			// readableRelations: formatRelations(item.relations || {})
		}))
};
